import { Container, Row } from "react-bootstrap";
import UnmatchedLeftPanel from "./leftPanel";
import { Column } from "../../../components";
import "./unmatched-policies.scss";
import CustomerDataSnapshot from "../../model/CustomerDataSnapshot";
import * as constant from '../../../shared/util/constant'
import * as label from '../../../shared/util/label'
import { useContext, useEffect, useState } from "react";
import TransactionSummary from "../../model/TransactionSummary";
import TransactionSummaryPanel from "../MiddlePane/transactionSummary";
import PolicyMappingDataService from "../PolicyMappingDataService";
import Logger from "../../../shared/services/Logger";
import CustomerTransactionSummary from "../../model/CustomerTransactionSummary";
import { MenuItem } from "primereact/menuitem";
import TransactionSummaryListPanel from "../RightPanel/transactionSummaryList";
import AtmsCustomers from "../../model/AtmsCustomers";
import { toast } from "react-toastify";
import { CustomerSearch } from "../../model/CustomerSearch";
import { AbilityContext } from "../../../shared/abilities/AbilityContext";
import { useHistory } from "react-router-dom";
import { TransactionMetadata } from "../../model/TransactionMetadata";


const UnmatchedPolicies = () => {
    const InitialInsuredSummary: CustomerDataSnapshot = {
        cycleBusinessPurposeCode: '',
        insuredsName: '',
        carrierName: '',
        id: constant.DEFAULT_GUID
    }


    const IntialTransactionSummary: TransactionSummary = {
        policyNumber: "",
        insuredsName: "",
        streetAddressLine1: "",
        city: "",
        stateProvinceAbbreviation: "",
        zipCode: "",
        insuredsTelephoneNumber: "",
        emailAddress:"",
        cycleBusinessPurposeCode: "",
        transactionDate: "",
        transactionEffectiveDate: "",
        cycleBusinessPurpose: "",
        lineOfBusinessCode: "",
        currentTermAmount: null,
        parentCompanyName:"",
        companyCode: "",
        mgaCode: "",
        id: constant.DEFAULT_GUID
    }


    const [insuredSummary, setInsuredSummary] = useState<CustomerDataSnapshot>(InitialInsuredSummary)
    const [insuredTransactionSummary, setTransactionSummary] = useState<TransactionSummary>(IntialTransactionSummary)
    const [transactionSummaryList, setTransactionSummaryList] = useState<CustomerTransactionSummary[]>([])
    const [insuredNameArray, setInsuredNameArray] = useState([])
    const [isNewCustomerLoad, setNewCustomerLoad] = useState(false)
    const [isNewCarrerLoad, setNewCarrierLoad] = useState(false)
    const [refreshCounter, setRefreshCounter] = useState(0);
    const [autoAdvanceCounter, setAutoAdvanceCounter] = useState(0);
    const policyMappingDataService = new PolicyMappingDataService();
    const [selectedTransactionIds, setSelectedTransactionIds] = useState<string[]>([]);
    const [transactionMetadataList, setTransactionMetadataList] = useState<TransactionMetadata[]>([]);

    const history = useHistory();
    const ability = useContext(AbilityContext);
    const canUserViewFile = ability.can('view', 'Assignments', constant.ScreenName.FILE);
    const canUserReadFile = ability.can('read', 'Assignments', constant.ScreenName.FILE);
 
    const [atmsCustomerList, setAtmsCustomerList] = useState<AtmsCustomers[]>([])
    const [defaultSelectedTab, setDefaultSelectedTab] = useState<string>(constant.UnMatchedPolicy.tab1);

     const hasUIComponentViewAccess = ability.can('view', 'Assignments', constant.UnMatchedPolicy.UI_COMPONENT);
    const hasUIComponentReadAccess = ability.can('read', 'Assignments', constant.UnMatchedPolicy.UI_COMPONENT);


    const hasAnyCustomerFilterValue = (filter: CustomerSearch): boolean => {
        return Object.values(filter).some(v => v !== undefined && v !== null && String(v).trim() !== '');
    };
 
    useEffect(() => {
         (!(canUserViewFile && canUserReadFile)) && history.push("/");
        setTransactionSummary(IntialTransactionSummary)
        setTransactionSummaryList([])
        setAtmsCustomerList([])
        setInsuredNameArray([])
        setNewCustomerLoad(true)
        if (insuredSummary.id !== constant.DEFAULT_GUID) {
            GetTransactionSummary(insuredSummary.id)
            let menuitem: MenuItem = insuredSummary
            let custNameArray = menuitem.label?.split(' ');
            setInsuredNameArray(custNameArray)
            if (custNameArray?.length > 0) {
                GetTransactionSummaryList({lastName: custNameArray[custNameArray?.length - 1]})
                setNewCustomerLoad(true)
                setNewCarrierLoad(false);
            }
        }
        else {
            setNewCarrierLoad(true)
        }
    }, [insuredSummary]);


    const GetTransactionSummary = async (policyId: string) => {
        try {
            var transactionSummary = await policyMappingDataService.fetchTransactionSummaryByPolicyId(policyId)
            setTransactionSummary(transactionSummary)
        }
        catch (error) {
            Logger.logError(constant.UnMatchedPolicy.ERROR_WHILE_FETCHING_CARRIER_MAPPING_LIST, error)
        }
    }

    const GetTransactionSummaryList = async (customerFilter : CustomerSearch) => {
        try {
            if (hasAnyCustomerFilterValue(customerFilter)) {
                setDefaultSelectedTab(constant.UnMatchedPolicy.tab1);
                var transactionSummaryList = await policyMappingDataService.fetchTransactionSummaryList(customerFilter);
                
                 if (transactionSummaryList.status === 206) {
                      toast.warning("More than 500 customers exist, but only 500 are currently displayed.");
                }
                setTransactionSummaryList(transactionSummaryList.data);
            }
        }
        catch (error) {
            Logger.logError(constant.UnMatchedPolicy.ERROR_WHILE_FETCHING_CARRIER_MAPPING_LIST, error)
        }
    }

    const GetCustomerFromATMSList = async (customerFilter : CustomerSearch) => {
        try {
            if (hasAnyCustomerFilterValue(customerFilter)) {
                var customerList = await policyMappingDataService.fetchAtsmsCustomerList(customerFilter);

                if (customerList.status === 206) {
                      toast.warning("More than 500 customers exist, but only 500 are currently displayed.");
                }

                setDefaultSelectedTab(constant.UnMatchedPolicy.tab2);
                setAtmsCustomerList(customerList.data);
            }
        }
        catch (error) {
            toast.error("Something went wrong while fetching customers from ATMS.", {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }
    return (

        <>

            <Row>
                <Column md={3} >
                    <UnmatchedLeftPanel
                        setInsuredSummary={setInsuredSummary}
                        setTransactionSummaryList={setTransactionSummaryList}
                        setAtmsCustomerList={setAtmsCustomerList}
                        refreshCounter={refreshCounter}
                        autoAdvanceCounter={autoAdvanceCounter}
                        hasUIComponentViewAccess={hasUIComponentViewAccess}
                        hasUIComponentReadAccess={hasUIComponentReadAccess}
                        selectedTransactionIds={selectedTransactionIds}
                        setSelectedTransactionIds={setSelectedTransactionIds}
                        setTransactionMetadataList={setTransactionMetadataList}
                    />
                </Column>

                <Column md={3} className="middle-panel-column">
                    <TransactionSummaryPanel
                        transactionSummary={insuredTransactionSummary}
                        onStatusChange={() => setRefreshCounter(count => count + 1)}
                    />
                </Column>
                <Column md={6} className="right-panel-column">
                    <TransactionSummaryListPanel
                        transactionSummaryData={transactionSummaryList}
                        atmCustomerData={atmsCustomerList}
                        transactionSummary={insuredTransactionSummary}
                        GetTransactionSummaryList={GetTransactionSummaryList}
                        GetCustomerFromATMSList={GetCustomerFromATMSList}
                        insuredNameArray={insuredNameArray}
                        insuredSummaryId={insuredSummary.id}
                        isNewCustomerLoad={isNewCustomerLoad}
                        setNewCustomerLoad={setNewCustomerLoad}
                        isNewCarrerLoad={isNewCarrerLoad}
                        onStatusChange={() => setRefreshCounter(count => count + 1)}
                        onApplySuccess={() => {
                            setAutoAdvanceCounter(count => count + 1);
                        }}
                        defaultSelectedTab={defaultSelectedTab}
                        hasUIComponentViewAccess={hasUIComponentViewAccess}
                        hasUIComponentReadAccess={hasUIComponentReadAccess}
                        selectedTransactionIds={selectedTransactionIds}
                        setSelectedTransactionIds={setSelectedTransactionIds}
                        transactionMetadataList={transactionMetadataList}
                    />
                </Column>
            </Row>


        </>
    )

}

export default UnmatchedPolicies;
